export default {
    GET_SHIPPING_ONLINE: '[SHIPPING] GET_SHIPPING_ONLINE',

    TYPE_GET_SHIPPING: 'get_shipping',

    GET_LIST_SHIPPING: '[SHIPPING] GET_LIST_SHIPPING',
    GET_LIST_SHIPPING_RESULT: '[SHIPPING] GET_LIST_SHIPPING_RESULT',
    POPUP_TYPE_SHIPPING: '[SHIPPING] POPUP',
    POPUP_TYPE_SHIPPING_ADDRESS: '[SHIPPING] POPUP_ADDRESS',
    GET_SHIPPING_METHODS: '[SHIPPING] GET_SHIPPING_METHODS',
    SAVE_SHIPPING: "[SHIPPING] SAVE_SHIPPING",
    SAVE_SHIPPING_AFTER: "[SHIPPING] SAVE_SHIPPING_AFTER",
    STORE_PICKUP_SHIPPING_METHOD_CODE: "webpos_shipping_storepickup",
    STORE_PICKUP_SHIPPING_METHOD_DESCRIPTION: "Pickup-at-store",
}



// WEBPACK FOOTER //
// ./src/view/constant/ShippingConstant.js